module.exports = [{"image":"River.png","name":"Watercourse","type":"square"},{"image":"Floodplain.png","name":"Waterbody","type":"square"},{"image":"LakeSimcoeProtectionPlan.png","name":"Floodplain","type":"square"},{"image":"Topography-1m.png","name":"Contours","type":"square"}]


//////////////////
// WEBPACK FOOTER
// ./public/data/water-legend.json
// module id = pgCl
// module chunks = 1